const SvgArrowDown = (props) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8Z" fill="#3763FF" />
  </svg>
);

export default SvgArrowDown;
